import { render, staticRenderFns } from "./ParentLogout.vue?vue&type=template&id=47e63c4a"
import script from "./ParentLogout.vue?vue&type=script&lang=js"
export * from "./ParentLogout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports